<template>
  <div>
    案例背景
  	<el-button type="primary" @click="next">下一步</el-button>
  </div>
</template>
<script>
import ajaxObj from "@/ajax";

export default {
  methods: {
    next() {
    
    }
  },

  created(){
  
  }
}

</script>


// WEBPACK FOOTER //
// src/views/background.vue